import cx from 'classnames';
import React from 'react';

import * as styles from './styles.css';
import Box, { BoxProps } from '../Box';

export interface FormItemProps extends BoxProps {
  label?: React.ReactNode;
  children: React.ReactNode;
  error?: React.ReactNode;
  warning?: React.ReactNode;
  helpText?: React.ReactNode;
}

const FormItem: React.FC<FormItemProps> = ({ className, label, children, helpText, error, warning, ...rest }) => {
  return (
    <Box
      className={cx(className, styles['form-item'])}
      display="flex"
      flexDirection="column"
      marginBottom={3}
      {...rest}
    >
      {label && <Box marginBottom={2}>{label}</Box>}
      {children}
      {helpText && <div className={styles['help-text']}>{helpText}</div>}
      {warning && <div className={styles['warning']}>{warning}</div>}
      {error && <div className={styles['error']}>{error}</div>}
    </Box>
  );
};

export default FormItem;
